<template>
    <div class="a-modal">
        <div class="popup__header popup__content--border-bot">
            <h3 class="title title--w550 title--sm popup__title" v-html="$lang('ProfileEditMoment.title')"></h3>
        </div>

        <div class="popup__content">
            <form class="a-modal__add-form form">
                <div class="form__item form__item--inline">
                    <div class="a-modal__inner">
                        <div class="form__label" v-html="$lang('ProfileEditMoment.date')"></div>
                        <el-date-picker
                            slot="reference"
                            v-model="wrapMoment.date"
                            class="date__picker date__picker--small date__picker--max-width"
                            type="date"
                            format="dd.MM.yyyy"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="pickerOptions"
                            placeholder="00.00.0000">
                        </el-date-picker>
                    </div>
                </div>

                <div class="form__item">
                    <div class="form__label" v-html="$lang('ProfileEditMoment.name')"></div>
                    <el-input
                        class="input input--small"
                        :placeholder="$lang('ProfileEditMoment.name.placeholder')"
                        v-model="wrapMoment.title"
                        :maxlength="maxLength.title"
                        clearable>
                    </el-input>
                </div>

                <div class="form__item">
                    <div class="form__label" v-html="$lang('ProfileEditMoment.photo')"></div>
                    <span class="memory__moment-crop">
                        <cropper-with-popover
                            id="cropPhoto"
                            v-model="wrapMoment.photo"
                            :width="655"
                            :height="350"
                            :ratio="655/350"
                            :popover-value="errors.cropPhoto.isError"
                            :content="errors.cropPhoto.message"
                            @crop="handlerCrop('cropPhoto', false)"
                            @update-photo="handlerCrop('cropPhoto', true)">
                        </cropper-with-popover>
                    </span>
                </div>

                <div class="form__item">
                    <div class="form__label" v-html="$lang('ProfileEditMoment.descr')"></div>
                    <el-input type="textarea"
                              class="input input--small input__textarea"
                              :rows="5"
                              resize="none"
                              v-model="wrapMoment.description"
                              :maxlength="maxLength.description"
                              clearable>
                    </el-input>
                </div>

                <div class="form__item">
                    <div class="form__label" v-html="$lang('ProfileEditMoment.tags')"></div>

                    <memories-edit-tags class="form__item" v-model="wrapMoment.tags"/>

                    <div class="memory__tag-hint" v-html="$lang('ProfileEditMoment.hint')"></div>

                    <button class="btn btn--big btn--main-bg"
                            @click.prevent="handlerMoment"
                            v-html="$lang('ProfileEditMoment.save.button')">
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import cropperWithPopover from "../cropper/cropperWithPopover";
import datepicker from "../../mixins/datepicker";
import MemoriesEditTags from "./MemoriesEditTags";
import validator from "../../mixins/validator";
import {mapMutations} from "vuex";
import Vue from "vue";

export default {
    name: 'MemoriesEditMoment',
    mixins: [datepicker, validator],
    components: {
        cropperWithPopover, MemoriesEditTags
    },
    props: {
        moment: {
            type: Object,
            default: () => ({
                title: '',
                description: '',
                date: null,
                photo: null,
                published: true,
                tags: []
            }),
        },
        index: {
            type: Number|null,
            default: null
        }
    },
    data() {
        return {
            wrapMoment: JSON.parse(JSON.stringify(this.moment)),
            rules: {
                cropPhoto: {
                    type: 'boolean',
                    required: true,
                    validator: (rule, value, cb) => {
                        value
                            ? cb()
                            : cb(new Error(Vue.prototype.$lang('addingMemorial.rules.cropper')));
                    },
                },
            },
            errors: {
                cropPhoto: {isError: false, message: ''},
            },
            croppedStatus: {
                cropPhoto: true
            },
            maxLength: {
                description: 1000,
                title: 50
            }
        }
    },
    methods: {
        ...mapMutations('profile', [
            'pushMoment',
            'updateMoment'
        ]),
        handlerMoment() {
            this.validate(() => {
                this.index !== null
                    ? this.updateMoment({value: this.wrapMoment, index: this.index})
                    : this.pushMoment(this.wrapMoment);

                this.$router.back();
            }, this.croppedStatus);
        }
    }
}
</script>
